// Libs
import Immutable from 'immutable';
import moment from 'moment';
// Utils
import sortBy from 'utils/orderBy';

const STATE_VIEWER_PERMISSION_KEYS = [
	'isTrasactionOpen',
	'isTransactionFrozen',
	'isOriginTransaction',
	'itemStateOptions',
	'itemStateOptionsStatus',
];

export const mergeStateViewerPermissions = (
	currentState = {},
	stateViewer = {},
) =>
	STATE_VIEWER_PERMISSION_KEYS.reduce(
		(nextState, key) =>
			Object.prototype.hasOwnProperty.call(stateViewer, key)
				? { ...nextState, [key]: stateViewer[key] }
				: nextState,
		{ ...currentState },
	);

export const getStableTableRowKey = (
	rowData = {},
	selectionKey = 'id',
	fallbackKey,
) => {
	const hasValue = value => value != null && value !== '';
	const serie = rowData.serie ?? rowData.serial;
	const selectionValue = rowData[selectionKey];

	if (hasValue(serie)) {
		const serieIdentity = [`serie:${serie}`];
		const serieId = rowData.serie_id ?? rowData.serieId;

		if (hasValue(serieId)) serieIdentity.push(`serie_id:${serieId}`);
		if (selectionKey !== 'serie' && hasValue(selectionValue))
			serieIdentity.push(`${selectionKey}:${selectionValue}`);

		return serieIdentity.join('|');
	}

	const candidates = [
		[selectionKey, selectionValue],
		['wtdi_id', rowData.wtdi_id ?? rowData.wtdiId],
		['item_id', rowData.item_id ?? rowData.itemId],
	];
	const identity = candidates.find(([, value]) => hasValue(value));

	return identity ? `${identity[0]}:${identity[1]}` : fallbackKey;
};

export const notifyVisibleDatasourceChange = (callback, datasource) => {
	if (typeof callback === 'function') callback(datasource);
};

export default class TableUtils {
	static filter(data, filters) {
		let _data = Immutable.List(data).toJS();
		if (!Object.keys(filters).length) return _data;

		for (const dataKey in filters) {
			const { checkedList } = filters[dataKey];
			const lowerCheckedList = checkedList.map(item => item.toLowerCase());

			_data = _data.filter(row => {
				const rowValue = row[dataKey]?.toString().toLowerCase();
				if (rowValue) return lowerCheckedList.indexOf(rowValue) !== -1;
			});
		}

		return _data;
	}

	/**
	 * The prop <dateFormat> is only required when <type> is "date"
	 * The prop <objectKey> is only required when <type> is "object"
	 * */
	static sort({ data, fields, dataKey, dateFormat, reverse } = {}) {
		if (!dataKey) return data;
		const copy = [...data];

		if (dataKey === '__priority__') {
			return copy.sort((a, b) => {
				const aOrder =
					typeof a.priority?.order === 'number' ? a.priority.order : Infinity;
				const bOrder =
					typeof b.priority?.order === 'number' ? b.priority.order : Infinity;
				return reverse ? bOrder - aOrder : aOrder - bOrder;
			});
		}

		if (dataKey.startsWith('__label__')) {
			const color = dataKey.replace('__label__', '');
			return copy.sort((a, b) => {
				const aMatch = a.priority?.style?.backgroundColor === color;
				const bMatch = b.priority?.style?.backgroundColor === color;
				if (aMatch && !bMatch) return reverse ? 1 : -1;
				if (!aMatch && bMatch) return reverse ? -1 : 1;
				return 0;
			});
		}

		if (!fields.length) return copy;
		const field = fields.find(field => field.id === dataKey);
		if (!field) return copy;

		const type =
			{
				date: 'objectDate',
				datetime: 'objectDate',
			}[field.type] || 'object';

		sortBy(copy, type, {
			dateFormat: field.dateFormat || dateFormat,
			objectKey: dataKey,
			reverse,
		});

		return copy;
	}
}

// return {
//   text: data.sort(),
//   numeric: data.sort((a, b) => a - b),
//   date: data.sort((a, b) => moment(a, dateFormat) - moment(b, dateFormat)),
//   objectDate: data.sort(function (a, b) {
//     if (reverse)
//       return (
//         moment(b[objectKey], dateFormat) - moment(a[objectKey], dateFormat)
//       );
//     return (
//       moment(a[objectKey], dateFormat) - moment(b[objectKey], dateFormat)
//     );
//   }),
//   object: data.sort(function (a, b) {
//     if (a[objectKey] > b[objectKey]) return 1;
//     if (a[objectKey] < b[objectKey]) return -1;
//     // a must be equal to b
//     return 0;
//   }),
// }[type];
